import React from "react";
import { LI, UL } from "../../../AbstractElements";

const CommonUL = () => {
  return (
    <UL className="simple-list d-flex flex-row">
      <LI></LI>
      <LI></LI>
      <LI></LI>
    </UL>
  );
};

export default CommonUL;
